import {create} from 'zustand';

type LanguageModalStore = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};

export const useLanguageModalStore = create<LanguageModalStore>(set => ({
  isOpen: false,
  open: () => set({isOpen: true}),
  close: () => set({isOpen: false}),
}));
